export default __webpack_public_path__ + "static/aurae-a9e3291dac4f814edb5635b14d5aefce.png";